var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning" },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.loading
        ? _c(
            "b-card",
            [
              _c(
                "b-card-body",
                [
                  _c("validation-observer", {
                    ref: "timesheet",
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var invalid = ref.invalid
                            return [
                              _c(
                                "b-form",
                                {
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.formSubmitted($event)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { md: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Project",
                                                "label-for": "project-dropdown",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules: "required",
                                                  name: "Project",
                                                  vid: "Project",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-select", {
                                                            attrs: {
                                                              id: "project-dropdown",
                                                              options:
                                                                _vm.Projects,
                                                              disabled:
                                                                _vm.type !==
                                                                  "add" ||
                                                                _vm.dis !==
                                                                  "add",
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.fetchTasks(
                                                                  _vm
                                                                    .timesheetDetails
                                                                    .parentID
                                                                )
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .timesheetDetails
                                                                  .parentID,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.timesheetDetails,
                                                                    "parentID",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "timesheetDetails.parentID",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Task",
                                                "label-for": "task-dropdown",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules: "required",
                                                  name: "Task",
                                                  vid: "Task",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-select", {
                                                            attrs: {
                                                              id: "task-dropdown",
                                                              options:
                                                                _vm.Tasks,
                                                              disabled:
                                                                !_vm.selectedProject ||
                                                                _vm.type !==
                                                                  "add" ||
                                                                _vm.dis !==
                                                                  "add",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .timesheetDetails
                                                                  .typeID,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.timesheetDetails,
                                                                    "typeID",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "timesheetDetails.typeID",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Approver",
                                                "label-for": "mc-approver",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules: "required",
                                                  name: "Approver",
                                                  vid: "Approver",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-select", {
                                                            attrs: {
                                                              id: "mc-approver",
                                                              disabled:
                                                                _vm.type !==
                                                                "add",
                                                              options:
                                                                _vm.userList,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .timesheetDetails
                                                                  .approverID,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.timesheetDetails,
                                                                    "approverID",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "timesheetDetails.approverID",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Reference",
                                                "label-for": "mc-reference",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules: "required",
                                                  name: "Reference",
                                                  vid: "Reference",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.type !==
                                                                "add",
                                                              id: "mc-Reference",
                                                              type: "text",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .timesheetDetails
                                                                  .reference,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.timesheetDetails,
                                                                    "reference",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "timesheetDetails.reference",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Start Time",
                                                "label-for": "mc-startTime",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules: "required",
                                                  name: "Start Time",
                                                  vid: "start Time",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c(
                                                            "b-form-timepicker",
                                                            {
                                                              attrs: {
                                                                id: "mc-startTime",
                                                                min: new Date(),
                                                                disabled:
                                                                  _vm.type !==
                                                                  "add",
                                                                locale: "en",
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.calculateHoursWorked,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .timesheetDetails
                                                                    .startTime,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.timesheetDetails,
                                                                      "startTime",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "timesheetDetails.startTime",
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "End Time",
                                                "label-for": "mc-endTime",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules: "required",
                                                  name: "End Time",
                                                  vid: "end Time",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c(
                                                            "b-form-timepicker",
                                                            {
                                                              attrs: {
                                                                id: "mc-endTime",
                                                                min: new Date(),
                                                                disabled:
                                                                  _vm.type !==
                                                                  "add",
                                                                locale: "en",
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.calculateHoursWorked,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .timesheetDetails
                                                                    .endTime,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.timesheetDetails,
                                                                      "endTime",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "timesheetDetails.endTime",
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Hours Worked",
                                                "label-for": "mc-hours",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules:
                                                    "required|min_value:0.01|max_value:24",
                                                  name: "Hours Worked",
                                                  vid: "Hours Worked",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              onkeydown:
                                                                "javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'",
                                                              disabled:
                                                                _vm.type !==
                                                                "add",
                                                              id: "mc-hours",
                                                              type: "text",
                                                              readonly: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .timesheetDetails
                                                                  .hoursWorked,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.timesheetDetails,
                                                                    "hoursWorked",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "timesheetDetails.hoursWorked",
                                                            },
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Date",
                                                "label-for": "mc-date",
                                              },
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules: "required",
                                                  name: "Date",
                                                  vid: "Date",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c(
                                                            "b-form-datepicker",
                                                            {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.type !==
                                                                  "add",
                                                                id: "mc-date",
                                                                max: _vm.today,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .timesheetDetails
                                                                    .date,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.timesheetDetails,
                                                                      "date",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "timesheetDetails.date",
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Description",
                                                "label-for":
                                                  "mc-taskDescription",
                                              },
                                            },
                                            [
                                              _c("b-form-textarea", {
                                                attrs: {
                                                  disabled: _vm.type !== "add",
                                                  id: "mc-taskDescription",
                                                  type: "text",
                                                },
                                                model: {
                                                  value:
                                                    _vm.timesheetDetails
                                                      .taskDescription,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.timesheetDetails,
                                                      "taskDescription",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "timesheetDetails.taskDescription",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.type !== "add"
                                        ? _c(
                                            "b-col",
                                            { attrs: { md: "6" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "Status",
                                                    "label-for": "mc-status",
                                                  },
                                                },
                                                [
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules: "required",
                                                      name: "Status",
                                                      vid: "Status",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (ref) {
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c(
                                                                "b-form-select",
                                                                {
                                                                  attrs: {
                                                                    id: "mc-status",
                                                                    disabled:
                                                                      _vm.type ===
                                                                        "view" ||
                                                                      _vm
                                                                        .timesheetDetails
                                                                        .approverID !==
                                                                        _vm.userId,
                                                                    options:
                                                                      _vm.timesheetStatus,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .timesheetDetails
                                                                        .status,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.timesheetDetails,
                                                                          "status",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "timesheetDetails.status",
                                                                  },
                                                                }
                                                              ),
                                                              _c(
                                                                "small",
                                                                {
                                                                  staticClass:
                                                                    "text-danger",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.type !== "add" &&
                                      _vm.timesheetDetails.status === "REJECTED"
                                        ? _c(
                                            "b-col",
                                            { attrs: { md: "6" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "Note",
                                                    "label-for": "mc-note",
                                                  },
                                                },
                                                [
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules: "required",
                                                      name: "Note",
                                                      vid: "Note",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (ref) {
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id: "mc-note",
                                                                    disabled:
                                                                      _vm.type ===
                                                                        "view" ||
                                                                      _vm
                                                                        .timesheetDetails
                                                                        .approverID !==
                                                                        _vm.userId,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .timesheetDetails
                                                                        .note,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.timesheetDetails,
                                                                          "note",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "timesheetDetails.note",
                                                                  },
                                                                }
                                                              ),
                                                              _c(
                                                                "small",
                                                                {
                                                                  staticClass:
                                                                    "text-danger",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.type !== "view"
                                    ? _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _vm.userId !==
                                              _vm.timesheetDetails.approverID
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      staticClass: "mt-2 mr-1",
                                                      attrs: {
                                                        variant: "primary",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.submitTimesheet,
                                                      },
                                                    },
                                                    [_vm._v(" Save ")]
                                                  )
                                                : _c(
                                                    "b-button",
                                                    {
                                                      staticClass: "mt-2 mr-1",
                                                      attrs: {
                                                        variant: "primary",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.submitTimesheet,
                                                      },
                                                    },
                                                    [_vm._v(" Update ")]
                                                  ),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "mt-2",
                                                  attrs: {
                                                    variant:
                                                      "outline-secondary",
                                                    type: "button",
                                                  },
                                                  on: {
                                                    click: _vm.resetTimesheet,
                                                  },
                                                },
                                                [_vm._v(" Cancel ")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      782232564
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }